@if (co2) {
  <ion-item lines="full" routerLink="/inventory/co2/details/{{ co2.id }}"
    data-testid="location-co2-item" [attr.data-co2-name]="co2.name">
    <ion-thumbnail slot="end">
      <app-co2-svg [item]="co2"></app-co2-svg>
    </ion-thumbnail>
    <ion-label>
      {{ co2.name }}
      @if (co2.plaato2) {
        <div>
          <ion-text class="color-medium">{{ co2.plaato2.name }}</ion-text>
        </div>
      }
      <div class="ps-badge-list">
        <ion-badge>Size: {{ co2.size }} {{ units()?.kegWeight }}</ion-badge>
        <ion-badge>Amount left: {{ co2.amount }} {{ units()?.kegWeight }}</ion-badge>
      </div>
    </ion-label>
  </ion-item>
}
